var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLumosityGlyph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5C8 8.70858 11.0309 5 16 5C18.8595 5 21.7449 6.79548 23.0941 9.42473L25.4835 15H23V21H19.3333L16.1923 28.5385L18.0385 29.3077L20.6667 23H23.75C24.4404 23 25 22.4404 25 21.75V17H26.6209C27.5183 17 28.1233 16.0824 27.7698 15.2576L24.9063 8.5762L24.8916 8.54721C23.2204 5.25625 19.6503 3 16 3C9.89506 3 6 7.63551 6 12.5C6 16.3667 7.95447 18.731 9.79089 20.3019L8.82692 22.6154C8.61451 23.1252 8.85558 23.7107 9.36539 23.9231C9.87519 24.1355 10.4607 23.8944 10.6731 23.3846L12.215 19.684L11.6188 19.2144C9.83108 17.8063 8 15.8809 8 12.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 27C9.05229 27 9.5 26.5523 9.5 26C9.5 25.4477 9.05229 25 8.5 25C7.94772 25 7.5 25.4477 7.5 26C7.5 26.5523 7.94772 27 8.5 27Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumosityGlyph);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;